module.exports = __webpack_public_path__ + "img/karen_akopyan-min.00a94037.jpg";